/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hidden_This_Listing_Is_Now_HiInputs */

const en_hidden_this_listing_is_now_hi = /** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden: This listing is now hidden from your storefront.`)
};

const id_hidden_this_listing_is_now_hi = /** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersembunyi: Listing ini sekarang disembunyikan dari etalase Anda.`)
};

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const es_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const fr_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const de_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const ja_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const zh_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const ar_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const it_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const ru_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const pt_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/** @type {(inputs: Hidden_This_Listing_Is_Now_HiInputs) => LocalizedString} */
const ko_hidden_this_listing_is_now_hi = en_hidden_this_listing_is_now_hi;

/**
* | output |
* | --- |
* | "Hidden: This listing is now hidden from your storefront." |
*
* @param {Hidden_This_Listing_Is_Now_HiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const hidden_this_listing_is_now_hi = /** @type {((inputs?: Hidden_This_Listing_Is_Now_HiInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hidden_This_Listing_Is_Now_HiInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hidden_this_listing_is_now_hi(inputs)
	if (locale === "es") return es_hidden_this_listing_is_now_hi(inputs)
	if (locale === "fr") return fr_hidden_this_listing_is_now_hi(inputs)
	if (locale === "de") return de_hidden_this_listing_is_now_hi(inputs)
	if (locale === "ja") return ja_hidden_this_listing_is_now_hi(inputs)
	if (locale === "zh") return zh_hidden_this_listing_is_now_hi(inputs)
	if (locale === "ar") return ar_hidden_this_listing_is_now_hi(inputs)
	if (locale === "id") return id_hidden_this_listing_is_now_hi(inputs)
	if (locale === "it") return it_hidden_this_listing_is_now_hi(inputs)
	if (locale === "ru") return ru_hidden_this_listing_is_now_hi(inputs)
	if (locale === "pt") return pt_hidden_this_listing_is_now_hi(inputs)
	return ko_hidden_this_listing_is_now_hi(inputs)
});